import {BasicPageLayoutNoSubscript} from "../Common/Elements/BasicPageLayout";
import {TaskList} from "./TaskList";
import React, {Context, createContext, useEffect, useState} from "react";
import {Task} from "../../types/farming";
import {loading} from "../../communication/wrapped";
import {getTasks, LOADED} from "../../communication/communication";
import {Loading, LoadingButton, LoadingList} from "../Common/Loading/LoadingPlaceholder";
import {ClaimTasksButton} from "./ClaimTasksButton";

export let ReloadTasksContext: Context<() => void>

const tasksLoading =
    <BasicPageLayoutNoSubscript height="100%" content={<div>
        <Loading className="loading-friends-board-header"/>
        <br/>
        <LoadingList count={6} height={"calc(var(--app-height) - 15rem)"}/>
    </div>} button={<>
        <LoadingButton/>
    </>}/>

export function TasksView() {
    const [tasks, setTasks] = useState(loading<Task[]>([]))

    useEffect(() => {
        getTasks().then(r => setTasks(r))
    }, []);

    ReloadTasksContext = createContext(() => {
        getTasks().then(r => setTasks(r))})

    if (tasks.statusCode !== LOADED || tasks.data === null) return tasksLoading

    const amountToClaim = tasks.data
        .filter(e => e.status === "Done")
        .reduce((a, c) => a + c.bonus, 0);

    const content = <TaskList tasks={tasks.data}/>

    return <BasicPageLayoutNoSubscript
        height="100%"
        content={content}
        button={<ClaimTasksButton amount={amountToClaim}/>}
    />
}